import React from "react";
import { Menubar } from "primereact/menubar";
import "primeicons/primeicons.css";
import { useNavigate } from "react-router-dom";
import "../App.css";

export default function BasicDemo() {
  const navigate = useNavigate();

  const items = [
    {
      label: "Home",
      icon: "pi pi-home",
      command: () => {
        navigate("/home");
      },
    },
    {
      label: "Profile",
      icon: "pi pi-user",
      command: () => {
        navigate("/profile");
      },
    },
    {
      label: "Tasks",
      icon: "pi pi-calendar",
      command: () => {
        navigate("/tasks");
      },
    },
    {
      label: "Qr Code",
      icon: "pi pi-qrcode",
      command: () => {
        navigate("/qrcode");
      },
    },
    {
      label: "Pdf",
      icon: "pi pi-file-pdf",
      command: () => {
        navigate("/pdfmerge");
      },
    },
  ];

  return <Menubar model={items} className="pt-3 " />;
}
